//extracted from icon-58-64-rounddismiss.svg
import React from 'react';
export const viewbox = '0 0 59 64';

export const content = (
  <>
    <defs>
      <style>
        .cls-1,.cls-2,.cls-3{'{fill:none;}'}.cls-2,.cls-3
        {'{stroke:#ef4538;}'}.cls-2{'{stroke-width:2px;}'}.cls-3
        {'{stroke-linejoin:round;stroke-width:3px;}'}
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Component_37" data-name="Component 37">
          <rect id="box" className="cls-1" x="7" width="24" height="48" />
          <g id="Ellipse_43" data-name="Ellipse 43">
            <circle className="cls-1" cx="29" cy="35" r="29" />
            <circle className="cls-2" cx="29" cy="35" r="28" />
          </g>
          <path
            id="Union_3"
            data-name="Union 3"
            className="cls-3"
            d="M29.5,34.5,21,43,29.5,34.5,21,26,29.5,34.5,38,26,29.5,34.5,38,43Z"
          />
        </g>
      </g>
    </g>
  </>
);

export default { viewbox, content };
